import React from "react";
import { CircleCheckBig } from "lucide-react";

export function ServiceCard({title,subtitle,port,uptime,memory,responseTime,image}) {
  return (
    <div
      className="bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl rounded-2xl p-4 border border-state-200/50 dark:border-slate-700/50 
           hover:shadow-xl hover:shadow-slate-900/20 transition-all duration-300 group "
    >
      <div className=" flex items-center justify-start space-x-2">
        <div className="w-10 h-10 bg-slate-200/60  p-1 rounded-lg flex items-center justify-center">
          <img
            src={image}
            alt="service logo"
          />
        </div>
        <div className="flex flex-col">
          <h1 className="text-xs font-bold-400 text-black dark:text-slate-200">
            {title}
          </h1>
          <p className="text-xs  font-medium text-black/50 dark:text-slate-600">
            {subtitle}
          </p>
        </div>
        <div className="flex items-center justify-start space-x-2 ml-auto">
          <CircleCheckBig className="w-4 h-4  text-blue-600 " />
          <h1 className="text-xs font-medium text-blue-600 rounded-xl border border-blue bg-blue-200/20 px-2 py-1 space-x-2">
            Healthy
          </h1>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-2 mt-4">
        <div className="">
          <span className="text-xs font-bold-200 text-black dark:text-slate-400/60">
            Port
          </span>
          <h1 className=" text-xs font-bold-200 text-black dark:text-slate-100 space-y-1">
            {port}
          </h1>
        </div>
        <div className="">
          <span className="text-xs font-bold-200 text-black dark:text-slate-400/60">
            Uptime
          </span>
          <h1 className=" text-xs font-bold-200 text-black dark:text-slate-100 space-y-1">
            {uptime}
          </h1>
        </div>
      </div>

      <div className="flex flex-col mt-4">
        <span className="text-xs font-bold-200 text-black dark:text-slate-400/60">
          Memory
        </span>
        <h1 className=" text-xs font-bold-200 text-black dark:text-slate-100 space-y-1">
          {memory}
        </h1>
      </div>
      <div className="flex flex-col mt-4">
        <span className="text-xs font-bold-200 text-black dark:text-slate-400/60">
          Response Time
        </span>
        <h1 className=" text-xs font-bold-200 text-black dark:text-slate-100 space-y-1">
            {responseTime}
        </h1>
      </div>
    </div>
  );
}
